import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './core/services/language.service';
import { UserDataService } from './core/services/user-data.service';
import { UiLanguage } from './core/interfaces/user-interfaces';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  constructor(private languageService: LanguageService, private userData: UserDataService) { }

  ngOnInit(): void {
    this.languageService.initLanguage();
    this.languageService.setToUserLanguage();
  }
}
